// import React from "react";
import { FC, ReactNode } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import { theme } from "../../../themes/index";
import { useAppSelector } from "../../../hooks/useRedux";

type props = { children: ReactNode };

const MaterialTheme: FC<props> = ({ children }) => {
  const themeMode = useAppSelector((state) => state.settings.themeMode);

  return (
    <ThemeProvider theme={theme(themeMode)}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default MaterialTheme;
